import { AlertBox } from '@iwoca/orion';

import styles from './PersonalDetailsCheckErrors.module.css';

type TProps = {
  hasDirectorDataRequirementError?: boolean;
  hasCreditDataRequirementError?: boolean;
  hasMissingEquifaxToken?: boolean;
};

const PersonalDetailsCheckErrors = ({
  hasDirectorDataRequirementError,
  hasCreditDataRequirementError,
  hasMissingEquifaxToken,
}: TProps) => {
  return (
    <AlertBox variant="failure" className={styles.container}>
      <p className={styles.errorInfo}>
        We were unable to run a soft credit check. To proceed, please ensure
        that the details below are correct:
      </p>
      <ul className={styles.errorList}>
        {hasDirectorDataRequirementError && (
          <>
            <li>Full name</li>
            <li>Date of birth</li>
          </>
        )}
        {hasMissingEquifaxToken && <li>Confirm your current address</li>}
        {hasCreditDataRequirementError && (
          <li>Address history for the last 6 years</li>
        )}
      </ul>
    </AlertBox>
  );
};

export default PersonalDetailsCheckErrors;
